import React from 'react'
import styled from 'styled-components'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

const Container = styled.div`
  width: 100%;
  background: rgba(226,232,236,.30);
  justify-content: flex-start;
  padding: 5px 24px 10px;
  align-items: flex-start;
`
const Table = styled.table`
  width: 100%;
  height: 100%;
  border-spacing:0;
  border-collapse: collapse;
`
const TableRow = styled.tr`
  display: flex;
  box-sizing: border-box;
  justify-content: flex-start;
  width: 100%;
`
const TableHeader = styled.th`
  display: flex;
  flex:1;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 4px;
  font-size: 12px;
`
const TableCell = styled.td`
  display: flex;
  flex:1;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 4px;
  font-size: 12px;
  background: rgba(226,232,236,.30);

`

const getName = (student) => {
  if (student.student) {
    if (student.is_virtual_center) {
      return (<span>{`${student.student.first_name}   ( Virtual )`}</span>)
    }
    return student.student.first_name
  }
  return null
}

const getStudents = (props) => {
  const { checkins_past24_hours } = props.row.original
  if (checkins_past24_hours &&
    checkins_past24_hours.length > 0) {
    const students = checkins_past24_hours.map(item => (
      <TableRow key={item.id}>
        <TableCell>
          {getName(item)}
        </TableCell>
      </TableRow>
    ))
    return students
  }
  return null
}

const Subcomponent = props => (
  <Container>
    <Table>
      <thead>
        <TableRow>
          <TableHeader>
            Alumnos
          </TableHeader>
        </TableRow>
      </thead>
      <tbody>
        {getStudents(props)}
      </tbody>
    </Table>
  </Container>
)

const mapStateToProps = () => ({
})

const mapDispatchToProps = () => ({
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Subcomponent))



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/Subcomponent.jsx